import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';
import { softieCardBase } from '../../shared/softieCardBase.styles';

export const CreateSoftieCardButton = styled.button`
	${softieCardBase}
	display: grid;
	place-content: center;
	justify-items: center;
	gap: 14px;
	border: 1px dashed rgba(255, 151, 242, 0.3);
	padding: 24px;
	color: rgba(255, 241, 253, 0.88);
	background:
		radial-gradient(circle at 50% 42%, rgba(255, 77, 242, 0.12), transparent 38%),
		linear-gradient(145deg, rgba(255, 255, 255, 0.055), rgba(255, 255, 255, 0.018)),
		rgba(12, 5, 17, 0.58);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.045);
	backdrop-filter: blur(18px);
	cursor: pointer;
	transition:
		transform 180ms ease,
		border-color 180ms ease,
		background 180ms ease,
		box-shadow 180ms ease;

	&:hover,
	&:focus-visible {
		transform: translateY(-3px);
		border-color: rgba(255, 126, 237, 0.58);
		background:
			radial-gradient(circle at 50% 42%, rgba(255, 77, 242, 0.2), transparent 40%),
			linear-gradient(145deg, rgba(255, 255, 255, 0.085), rgba(255, 255, 255, 0.025)),
			rgba(16, 6, 22, 0.7);
		box-shadow:
			0 20px 48px rgba(0, 0, 0, 0.28),
			0 0 24px rgba(255, 77, 242, 0.1);
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		padding: 16px;
		gap: 10px;

		&:hover,
		&:focus-visible {
			transform: none;
		}
	}
`;

export const CreateSoftieIcon = styled.span`
	width: 56px;
	height: 56px;
	display: grid;
	place-items: center;
	border: 1px solid rgba(255, 154, 241, 0.34);
	border-radius: 50%;
	color: #f776ed;
	background: rgba(255, 77, 242, 0.08);
	box-shadow: 0 0 24px rgba(255, 77, 242, 0.12);

	svg {
		width: 24px;
		height: 24px;
		fill: none;
		stroke: currentColor;
		stroke-width: 1.8;
		stroke-linecap: round;
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		width: 44px;
		height: 44px;

		svg {
			width: 20px;
			height: 20px;
		}
	}
`;

export const CreateSoftieLabel = styled.strong`
	max-width: 130px;
	font-size: 0.92rem;
	font-weight: 700;
	line-height: 1.25;
	text-align: center;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		max-width: none;
		font-size: 0.8125rem;
		line-height: 1.2;
	}
`;
